import React from "react";
import {
  GreetingBoxChunk,
  BalanceBoxChunk,
  NotificationBoxChunk,
  LoyaltyIndicatorBoxChunk,
  ControlCenterBoxChunk,
  LinksBoxChunk
} from "./chunksComponents";
import { PageContextUtils } from "../../utils";
import MyAccountAreaFooter from "./components/MyAccountAreaFooter/MyAccountAreaFooter";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../redux/selectors";
import {
  MyAccountAreaMenuComponents,
  MyAccountAreaWrapper
} from "./myAccountAreaWrapper";
import { TrackingInfo } from "../tracking/TrackingInfoMyAccountArea";

const MyAccountArea = () => {
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const { myAccountAreaComponents } = PageContextUtils.getVisualData();

  return (
    <MyAccountAreaWrapper data-testid="uc-my-account-area-content">
      <MyAccountAreaMenuComponents>
        {myAccountAreaComponents.map((comp, index) => {
          const components = {
            GREETING_BOX: (
              <GreetingBoxChunk key={index} trackingInfo={TrackingInfo} />
            ),
            BALANCE_BOX: (
              <BalanceBoxChunk key={index} trackingInfo={TrackingInfo} />
            ),
            NOTIFICATION_BOX: isMobile && (
              <NotificationBoxChunk
                key={index}
                properties={comp.properties}
                trackingInfo={TrackingInfo}
                height="3.2rem"
                width="3.3rem"
              />
            ),
            LOYALTY_INDICATOR_BOX: isMobile && (
              <LoyaltyIndicatorBoxChunk
                key={index}
                trackingInfo={TrackingInfo}
              />
            ),
            CONTROL_CENTER_BOX: (
              <ControlCenterBoxChunk key={index} trackingInfo={TrackingInfo} />
            ),
            LINKS_BOX: (
              <LinksBoxChunk
                key={index}
                properties={comp.properties}
                trackingInfo={TrackingInfo}
              />
            )
          };
          return components[comp.id] || null;
        })}
      </MyAccountAreaMenuComponents>
      <MyAccountAreaFooter />
    </MyAccountAreaWrapper>
  );
};

export default React.memo(MyAccountArea);
